export default __webpack_public_path__ + "static/video-wiz-2-4136b50f25fa86032e94960fb188ba7c.mp4";